import { Entry } from 'contentful';
import { IPageSectionFields } from '../../../types/@types/generated/contentful';
import { Color, colors } from '../../../utils/styleguide';
import buttonToCompatibleProps from './buttonToCompatibleProps';
import orientedMediaToCompatibleProps from './orientedMediaToCompatibleProps';

const sectionToCompatibleProps = ({ section }: { section: Entry<IPageSectionFields> }) => {
  const {
    background,
    backgroundEntry,
    buildingBlock,
    orientedMedia,
    title,
    description,
    help,
    settings,
    reversed,
    reversedMobile,
    image,
    variant,
  } = section.fields || {};

  const media = orientedMediaToCompatibleProps({ orientedMedia, image, settings });
  const button = buttonToCompatibleProps({ button: buildingBlock?.fields.button, settings });
  const backgroundMedia = orientedMediaToCompatibleProps({
    orientedMedia: backgroundEntry?.fields.orientedMedia,
  });

  return {
    id: (settings?.id as string) || section.sys.id,
    title: buildingBlock?.fields.title || title,
    description: buildingBlock?.fields.description || description,
    media,
    help,
    reversed: reversed || (settings?.reversed as boolean | undefined),
    reversedMobile: reversedMobile || (settings?.reversedMobile as boolean | undefined),
    backgroundImage: backgroundMedia.image || background,
    backgroundImageLandscape: backgroundMedia.imageLandscape,
    backgroundImagePortrait: backgroundMedia.imagePortrait,
    rawBackgroundColor: getBackgroundColor({ backgroundEntry, settings }),
    backgroundColor:
      backgroundEntry?.fields.color || (settings?.backgroundColor as Color | undefined),
    backgroundLinear: backgroundEntry?.fields.linear || settings?.backgroundLinear,
    button,
    logos: buildingBlock?.fields.logos,
    variant,
  };
};

const getBackgroundColor = ({
  backgroundEntry,
  settings,
}: Pick<IPageSectionFields, 'backgroundEntry' | 'settings'>) => {
  if (backgroundEntry?.fields.color) {
    return colors[backgroundEntry?.fields.color];
  }
  if (!settings?.backgroundColor) {
    return;
  }
  if (Object.keys(colors).includes(settings.backgroundColor)) {
    return colors[settings.backgroundColor as Color];
  }
  return settings?.backgroundColor as string | undefined;
};

export default sectionToCompatibleProps;
